export default "__VITE_ASSET__BXGmf3Yq__"